import { useState } from "react";

import { Button, MenuItem, Select, Typography } from "@mui/material";
import classNames from "classnames";
import { IoSync } from "react-icons/io5";

import { useMyCourseInstructor } from "../../hooks/useMyCourseInstructor";

export function MyCourseCategory() {
	const { course, categories, updateCourseBasicInformation } =
		useMyCourseInstructor();
	const [category, setCategory] = useState(course?.category ?? "Others");
	const [loading, setLoading] = useState(false);

	if (!course) {
		return null;
	}

	const onClickCancel = () => {
		setCategory(course.category);
	};

	const onClickUpdate = async () => {
		if (isDisabled) {
			return;
		}

		setLoading(true);
		await updateCourseBasicInformation({ category });
		setLoading(false);
	};

	const isEdited = category !== course.category && !loading;
	const isDisabled = !isEdited || loading;

	return (
		<>
			<div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
				<Typography className="small-title-text bold">
					4. Select best training category
				</Typography>
				{loading && (
					<div>
						<IoSync className="normal-icon rotation-icon blue-icon" />
					</div>
				)}
			</div>
			<Typography className="normal-text">
				Which of these resonates the most with what students get out of your
				training?
			</Typography>
			<div className="common-select normal-text item-separator-small">
				<Select
					value={category}
					fullWidth
					onChange={(e) => {
						setCategory(e.target.value);
					}}>
					{categories.map((category) => (
						<MenuItem
							className="normal-text"
							key={category.id}
							value={category.name}>
							{category.name}
						</MenuItem>
					))}
				</Select>
			</div>
			<div className="button-container item-separator-small">
				<Button
					className="normal-button disabled-button"
					disabled={!isEdited}
					onClick={onClickCancel}>
					Cancel
				</Button>
				<Button
					disabled={isDisabled}
					className={classNames("normal-button", {
						"primary-button": !isDisabled,
						"disabled-button": isDisabled,
					})}
					onClick={onClickUpdate}>
					Save
				</Button>
			</div>
		</>
	);
}
